import React from 'react';
import DataRequestGuide from '../../components/DataRequestGuide';
const steps = [
    {
        id: 'deepseek-step-1',
        stepLabel: 'Step 1',
        title: 'Where should you begin?',
        image: process.env.PUBLIC_URL + '/Images/steps/Deepseek_Step1.png',
        imageAlt: 'DeepSeek home screen with menu icon highlighted',
        body: (
        <>
            Open the DeepSeek app or go to{' '}
            <a href="https://chat.deepseek.com/" target="_blank" rel="noreferrer">
            deepseek.ai
            </a>
            , then press on the two horizontal bars at the top left of the screen.
            (If the side menu is already visible, you can skip this step.)
        </>
        ),
    },
    {
        id: 'deepseek-step-2',
        stepLabel: 'Step 2',
        title: 'Open your profile menu',
        image: process.env.PUBLIC_URL + '/Images/steps/Deepseek_Step2.png',
        imageAlt: 'Profile icon highlighted in DeepSeek',
        body: (
        <>
            Click on your profile icon, located where your username appears at the
            bottom left of the menu.
        </>
        ),
    },
    {
        id: 'deepseek-step-3',
        stepLabel: 'Step 3',
        title: 'Go to settings',
        image: process.env.PUBLIC_URL + '/Images/steps/Deepseek_Step3.png',
        imageAlt: 'Settings option highlighted in DeepSeek menu',
        body: (
        <>
            In the pop-up menu, click on <strong>Settings</strong>.
        </>
        ),
    },
    {
        id: 'deepseek-step-4',
        stepLabel: 'Step 4',
        title: 'Open Data ',
        image: process.env.PUBLIC_URL + '/Images/steps/Deepseek_Step4.png',
        imageAlt: 'Data button highlighted in settings',
        body: (
        <>
            In the settings panel, press the <strong>Data</strong> button (press the right arrow key if it does not appear). Then, in the Data panel, click on <strong>Export</strong>.
        </>
        ),
    },
];

const DeepSeekRequest = () => {
    return (
        <DataRequestGuide
        title="How to Request Your DeepSeek Data"
        intro="Follow these steps to export a copy of your DeepSeek data, which you can then donate through this website."
        steps={steps}
        />
    );
};

export default DeepSeekRequest;
